import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    component: () => import("@/views/layout/Base.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/services/OurServicesPage.vue"),
        name: "home",
        meta: {
          breadcrumb: "Página de inicio",
        },
      },
      {
        path: "our-services",
        redirect: { name: "home" },
      },
      {
        path: "questions",
        component: () => import("@/views/support/QuestionsPage.vue"),
        name: "questions",
        meta: {
          breadcrumb: "Preguntas frecuentes",
        },
      },
      {
        path: "terms-and-conditions",
        component: () => import("@/views/legal/TermsAndConditions.vue"),
        name: "terms-and-conditions",
        meta: {
          breadcrumb: "Terminos",
        },
      },
      {
        path: "termsAndConditions",
        redirect: { name: "terms-and-conditions" },
      },
      {
        path: "privacy-notice",
        component: () => import("@/views/legal/PrivacyAdvice.vue"),
        name: "privacy-notice",
        meta: {
          breadcrumb: "Terminos",
        },
      },
      {
        path: "privacyAdvice",
        redirect: { name: "privacy-notice" },
      },
      {
        path: "services-and-claims",
        component: () => import("@/views/support/ServicesAndClaimsPage.vue"),
        name: "services-and-claims",
        meta: {
          breadcrumb: "Servicios y Siniestros",
        },
      },
      {
        path: "billing-data",
        component: () => import("@/views/checkout/BillingData.vue"),
        name: "billing-data",
        meta: {
          breadcrumb: "BillingData",
        },
      },
      {
        path: "billingData",
        redirect: { name: "billing-data" },
      },
      {
        path: "promotions",
        component: () => import("@/views/marketing/PromotionsPage.vue"),
        name: "promotions",
        meta: {
          breadcrumb: "Promociones",
        },
      },
      {
        path: "contact-us",
        component: () => import("@/views/support/ContactUsPage.vue"),
        name: "contact-us",
        meta: {
          breadcrumb: "Contactanos",
        },
      },
      {
        path: "data-for-services",
        component: () => import("@/views/services/DataForServicesPage.vue"),
        name: "data-for-services",
        meta: {
          breadcrumb: "Cuentame un poco de ti",
          transition: "fade",
        },
      },
      {
        path: "filtered-products",
        component: () => import("@/views/services/FilteredProductsPage.vue"),
        name: "filtered-products",
        meta: {
          breadcrumb: "Productos adecuados para ti",
          transition: "fade",
        },
      },
      {
        path: "shopping-cart",
        component: () => import("@/views/checkout/ShoppingCarPage.vue"),
        name: "shopping-cart",
        meta: {
          breadcrumb: "Carrito de compra",
          transition: "fade",
        },
      },
      {
        path: "shopping-car",
        redirect: { name: "shopping-cart" },
      },
      {
        path: "payment-collection",
        component: () => import("@/views/checkout/PaymentCollectionPage.vue"),
        name: "payment-collection",
        meta: {
          breadcrumb: "Carrito de compra",
          transition: "fade",
        },
      },
      {
        path: "in-search",
        component: () => import("@/views/support/InSearchPage.vue"),
        name: "in-search",
        meta: {
          breadcrumb: "Contactanos",
        },
      },
      {
        path: "confirm-email/:id",
        component: () => import("@/views/user/ConfirmEmailPage.vue"),
        name: "confirm-email",
        meta: {
          breadcrumb: "Confirmación de registro",
        },
      },
      {
        path: "user/policy-list",
        component: () => import("@/views/user/UserPolicyListPage.vue"),
        name: "user-policy-list",
        meta: {
          breadcrumb: "Listado de pólizas",
        },
      },
      {
        path: "user/detail",
        component: () => import("@/views/user/UserDetailPage.vue"),
        name: "user-detail",
        meta: {
          breadcrumb: "Detalles de usuario",
        },
      },
      {
        path: "user/register",
        component: () => import("@/views/user/UserRegisterPage.vue"),
        name: "user-register",
        meta: {
          breadcrumb: "Registro de usuario",
        },
      },
      {
        path: "payments/confirm/8/:id",
        component: () => import("@/views/payments/PaymentChubb.vue"),
        name: "chubb-payment-confirm",
      },
      {
        path: "payments/confirm/4/:id",
        component: () => import("@/views/payments/PaymentCovid.vue"),
        name: "covid-payment-confirm",
      },
      {
        path: "payments/confirm/5/:id",
        component: () => import("@/views/payments/PaymentDentegra.vue"),
        name: "dentegra-payment-confirm",
      },
      {
        path: "payments/confirm/11/:id",
        component: () => import("@/views/payments/PaymentSurgical.vue"),
        name: "surgical-payment-confirm",
      },
      {
        path: "payments/confirm/6/:id",
        component: () => import("@/views/payments/PaymentFuneral.vue"),
        name: "funeral-payment-confirm",
      },
      {
        path: "payments/confirm/1/:id",
        component: () =>
          import("@/views/payments/PaymentPersonalAccidents.vue"),
        name: "personal-accidents-payment-confirm",
      },
      {
        path: "reset-password/:uid/:token",
        component: () => import("@/views/user/UserResetPassword.vue"),
        name: "reset-password",
      },
      {
        path: "reset_password/:uid/:token",
        redirect: (to) => ({
          name: "reset-password",
          params: to.params,
        }),
      },
      {
        path: "test-charges",
        component: () => import("@/views/test/CargosPrueba.vue"),
        name: "test-charges",
      },
      {
        path: "cargos-prueba",
        redirect: { name: "test-charges" },
      },
      {
        path: "insurance/:insurance/:client",
        component: () => import("@/views/marketing/MicroSite.vue"),
        name: "insurance",
      },
      {
        path: "seguro/:insurance/:client",
        redirect: (to) => ({
          name: "insurance",
          params: to.params,
        }),
      },
      // Legacy absolute paths with trailing slashes
      {
        path: "/user/policy-list/",
        redirect: { name: "user-policy-list" },
      },
      {
        path: "/user/detail/",
        redirect: { name: "user-detail" },
      },
      {
        path: "/user/register/",
        redirect: { name: "user-register" },
      },
      {
        path: "/cargos-prueba/",
        redirect: { name: "test-charges" },
      },
    ],
  },

  {
    path: "/simple",
    component: () => import("@/views/layout/BaseSimple.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/services/OurServicesPageSimple.vue"),
        name: "simple-home",
        meta: {
          breadcrumb: "Página de inicio Secundaria",
        },
      },
      {
        path: "data-for-services",
        component: () => import("@/views/services/DataForServicesPage.vue"),
        name: "data-for-simple-services",
        meta: {
          breadcrumb: "Cuentame un poco de ti",
          transition: "fade",
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (
      to.name === "terms-and-conditions" ||
      to.name === "privacy-notice"
    ) {
      return false;
    }
    return { top: 0 };
  },
});

export default router;
